/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DepartmentIncludeFilterInner } from './departmentIncludeFilterInner';
import { DepartmentFields } from './departmentFields';
import { AcademicLevelFilterOrder } from './academicLevelFilterOrder';


export interface DepartmentFilter1 { 
    offset?: number;
    limit?: number;
    skip?: number;
    order?: AcademicLevelFilterOrder;
    where?: { [key: string]: any; };
    fields?: DepartmentFields;
    include?: Array<DepartmentIncludeFilterInner>;
}

